import { APIMethod, fetchData } from "@client";

export async function fetchGroupedProjectVersionCommentsQuery(
  projectUuidOrHash,
  userUuid=undefined,
  versionKey,
) {
  const res = await fetchData(
    `/v1/ws/project/comments/grouped/${projectUuidOrHash}${versionKey ? "/" : ""}${versionKey || ""}`,
    APIMethod.GET,
    {
      params: {
        user: userUuid
      }
    }
  );
  return res.results;
}
